import { get } from 'lodash';
import AdvancedStatusInput from '../../Status/AdvancedStatusInput';
import { NewPaperWithPadding, PaperSectionTitle } from '@components/Misc';
import { Paper } from '@mui/material';
import { Grid, Checkbox, Typography } from '@ts/storybook';
import { useTranslation } from 'react-i18next';
import { IAppProps } from '@interfaces/App.interface';
import { IForm } from '@ts/ui-models';

interface IEventTypeLocationRulesTabProps extends IForm, IAppProps {}

const EventTypeLocationRulesTab = (props: IEventTypeLocationRulesTabProps) => {
  const { mode, values, onChange, onCallbackChange } = props;

  const isDisabled = mode === 'view';
  const shouldUpdateLocationStatus = values.updatesLocationStatus;

  const handleCheckboxChange = (value: boolean) => {
    onChange('updatesLocationStatus', value);
  };

  const indicators = get(values, 'locationStatusUpdate.indicators', []) ?? [];

  const handleStatusListChange = (newList: any[]) => {
    const { locationStatusUpdate } = values;
    if (locationStatusUpdate) {
      onCallbackChange('locationStatusUpdate.indicators')(newList);
    } else {
      onCallbackChange('locationStatusUpdate')({
        type: 'operation',
        indicators: newList,
      });
    }
  };

  return (
    <Grid container>
      <NewPaperWithPadding>
        <Grid container spacing={2} direction={'column'}>
          <Typography variant="h6" text="Change status" />

          <Checkbox
            key="chkbx"
            disabled={isDisabled}
            label="Update the status of the location where the event of this type happens"
            checked={shouldUpdateLocationStatus}
            onChangeValue={handleCheckboxChange}
          />

          {shouldUpdateLocationStatus && (
            <AdvancedStatusInput
              {...props}
              key="sop"
              title={'Indicators to update in the location'}
              statesList={indicators}
              onChangeList={handleStatusListChange}
              isAdvancedSearch={false}
            />
          )}
        </Grid>
      </NewPaperWithPadding>
    </Grid>
  );
};

export default EventTypeLocationRulesTab;
